<p>List of referred users</p>


<div class="user-info" *ngFor="let user of referredUsers">
  <img [src]="user.image_url" alt="{{ user.name }}'s profile image" class="profile-image">
  <div class="user-name">{{ user.name }} {{ user.surname }}</div>
</div>
